(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  function initCart(root = document) {
    root.querySelectorAll('[data-cart-section]').forEach((cartSection) => {
      if (cartSection.dataset.cartReady === 'true') return;
      cartSection.dataset.cartReady = 'true';

      const form = cartSection.querySelector('[data-cart-form]');
      if (!form) return;

      const errorMessage = cartSection.querySelector('[data-cart-error-message]');
      const statusMessage = cartSection.querySelector('[data-cart-status]');
      let updateTimer;
      let updateController;

      const setLoading = (loading) => {
        cartSection.classList.toggle('is-updating', loading);
        statusMessage.hidden = !loading;
        form.querySelectorAll('button, input, textarea').forEach((control) => {
          control.disabled = loading;
        });
      };

      const showError = (message) => {
        errorMessage.textContent = message || cartSection.dataset.cartError;
        errorMessage.hidden = false;
      };

      const updateCartCount = (count) => {
        const cartLink = document.querySelector('.site-header__icons a[href*="/cart"]');
        if (!cartLink) return;

        let badge = cartLink.querySelector('sup');
        if (count > 0) {
          if (!badge) {
            badge = document.createElement('sup');
            cartLink.prepend(badge);
          }
          badge.textContent = count;
        } else {
          badge?.remove();
        }
      };

      const renderCart = (html, itemCount) => {
        const documentFragment = new DOMParser().parseFromString(html, 'text/html');
        const replacement = documentFragment.querySelector('[data-cart-section]');
        if (!replacement) throw new Error(cartSection.dataset.cartError);

        cartSection.replaceWith(replacement);
        updateCartCount(itemCount);
        initCart(document);
      };

      const changeLine = async (lineKey, quantity) => {
        updateController?.abort();
        updateController = new AbortController();
        errorMessage.hidden = true;
        setLoading(true);

        try {
          const response = await fetch(`${window.Shopify.routes.root}cart/change.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            body: JSON.stringify({
              id: lineKey,
              quantity,
              sections: [cartSection.dataset.sectionId],
              sections_url: window.location.pathname
            }),
            signal: updateController.signal
          });
          const cart = await response.json();

          if (!response.ok) {
            throw new Error(cart.description || cart.message || cartSection.dataset.cartError);
          }

          const renderedSection = cart.sections?.[cartSection.dataset.sectionId];
          if (!renderedSection) throw new Error(cartSection.dataset.cartError);
          renderCart(renderedSection, cart.item_count);
        } catch (error) {
          if (error.name === 'AbortError') return;
          setLoading(false);
          showError(error.message);
        }
      };

      const queueChange = (input) => {
        window.clearTimeout(updateTimer);
        updateTimer = window.setTimeout(() => {
          changeLine(input.dataset.lineKey, Math.max(0, Number(input.value || 0)));
        }, 300);
      };

      form.querySelectorAll('[data-quantity-input]').forEach((input) => {
        const control = input.closest('.renims-cart__quantity-control');
        const minus = control.querySelector('[data-quantity-minus]');
        const plus = control.querySelector('[data-quantity-plus]');

        minus.addEventListener('click', () => {
          input.value = Math.max(0, Number(input.value || 0) - 1);
          queueChange(input);
        });

        plus.addEventListener('click', () => {
          input.value = Number(input.value || 0) + 1;
          queueChange(input);
        });

        input.addEventListener('change', () => queueChange(input));
      });
    });
  }

  initCart();
  document.addEventListener('shopify:section:load', (event) => initCart(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  (() => {
    const storageKey = 'renims-collection-mobile-columns';

    const setColumns = (section, columns) => {
      const value = columns === '1' ? '1' : '2';
      section.dataset.mobileColumns = value;
      section.querySelectorAll('[data-collection-columns]').forEach((button) => {
        const isActive = button.dataset.collectionColumns === value;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', String(isActive));
      });
    };

    const setup = (scope = document) => {
      scope.querySelectorAll('.collection-page').forEach((section) => {
        if (section.dataset.collectionLayoutReady === 'true') return;
        section.dataset.collectionLayoutReady = 'true';

        let savedColumns = '2';
        try {
          savedColumns = localStorage.getItem(storageKey) || '2';
        } catch (error) {
          savedColumns = '2';
        }
        setColumns(section, savedColumns);

        const drawer = section.querySelector('.collection-page__filters');
        const backdrop = section.querySelector('.collection-page__filters-backdrop');
        const openButton = section.querySelector('[data-filter-open]');

        const openDrawer = () => {
          if (!drawer || !backdrop || !openButton) return;
          drawer.classList.add('is-open');
          backdrop.classList.add('is-open');
          openButton.setAttribute('aria-expanded', 'true');
          document.body.classList.add('collection-filters-open');
          drawer.querySelectorAll('.collection-page__filter').forEach((details, index) => {
            if (index < 2) details.open = true;
          });
          drawer.querySelector('[data-filter-close]')?.focus();
        };

        const closeDrawer = (restoreFocus = true) => {
          if (!drawer || !backdrop || !openButton) return;
          drawer.classList.remove('is-open');
          backdrop.classList.remove('is-open');
          openButton.setAttribute('aria-expanded', 'false');
          document.body.classList.remove('collection-filters-open');
          if (restoreFocus) openButton.focus();
        };

        section.addEventListener('click', (event) => {
          const filterOpen = event.target.closest('[data-filter-open]');
          if (filterOpen) {
            event.preventDefault();
            openDrawer();
            return;
          }

          const filterClose = event.target.closest('[data-filter-close]');
          if (filterClose) {
            event.preventDefault();
            closeDrawer();
            return;
          }

          const button = event.target.closest('[data-collection-columns]');
          if (!button) return;
          const columns = button.dataset.collectionColumns;
          setColumns(section, columns);
          try {
            localStorage.setItem(storageKey, columns);
          } catch (error) {
            return;
          }
        });

        document.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && drawer?.classList.contains('is-open')) {
            closeDrawer();
          }
        });
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => setup());
    } else {
      setup();
    }
    document.addEventListener('shopify:section:load', (event) => setup(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  function initStickyHeader(root = document) {
    const header = root.querySelector('.site-header') || document.querySelector('.site-header');
    if (!header || header.dataset.stickyReady === 'true') return;

    header.dataset.stickyReady = 'true';

    const updateHeader = () => {
      header.classList.toggle('is-scrolled', window.scrollY > 24);
    };

    updateHeader();
    window.addEventListener('scroll', updateHeader, { passive: true });
  }

  function initMobileHeader(root = document) {
    root.querySelectorAll('[data-mobile-menu]').forEach((drawer) => {
      if (drawer.dataset.mobileReady === 'true') return;

      drawer.dataset.mobileReady = 'true';

      const section = drawer.closest('.shopify-section') || document;
      const openButton = section.querySelector('[data-mobile-menu-open]');
      const closeButtons = drawer.querySelectorAll('[data-mobile-menu-close]');

      const open = () => {
        drawer.classList.add('is-open');
        drawer.setAttribute('aria-hidden', 'false');
        openButton?.setAttribute('aria-expanded', 'true');
        document.documentElement.classList.add('mobile-menu-open');
      };

      const close = () => {
        drawer.classList.remove('is-open');
        drawer.setAttribute('aria-hidden', 'true');
        openButton?.setAttribute('aria-expanded', 'false');
        document.documentElement.classList.remove('mobile-menu-open');
      };

      openButton?.addEventListener('click', open);
      closeButtons.forEach((button) => button.addEventListener('click', close));

      drawer.querySelectorAll('a').forEach((link) => {
        link.addEventListener('click', close);
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && drawer.classList.contains('is-open')) {
          close();
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initStickyHeader();
      initMobileHeader();
    });
  } else {
    initStickyHeader();
    initMobileHeader();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initStickyHeader(event.target);
    initMobileHeader(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hello-world"] && !Shopify.designMode) return;
  try {
    
  function initRenimsHeroSlider(root = document) {
    root.querySelectorAll('[data-hero-slider]').forEach((slider) => {
      if (slider.dataset.sliderReady === 'true') return;
      slider.dataset.sliderReady = 'true';

      const slides = [...slider.querySelectorAll('[data-hero-slide]')];
      const dots = [...slider.querySelectorAll('[data-slide-dot]')];
      const previousButton = slider.querySelector('[data-slide-previous]');
      const nextButton = slider.querySelector('[data-slide-next]');
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      let activeIndex = 0;
      let autoplayTimer;

      if (slides.length < 2) return;

      const showSlide = (index) => {
        activeIndex = (index + slides.length) % slides.length;

        slides.forEach((slide, slideIndex) => {
          const isActive = slideIndex === activeIndex;
          slide.classList.toggle('is-active', isActive);
          slide.setAttribute('aria-hidden', String(!isActive));
          slide.inert = !isActive;
        });

        dots.forEach((dot, dotIndex) => {
          dot.setAttribute('aria-current', String(dotIndex === activeIndex));
        });
      };

      const stopAutoplay = () => window.clearInterval(autoplayTimer);
      const startAutoplay = () => {
        stopAutoplay();
        if (slider.dataset.autoplay !== 'true' || reduceMotion) return;
        const delay = Math.max(3, Number(slider.dataset.autoplaySeconds) || 5) * 1000;
        autoplayTimer = window.setInterval(() => showSlide(activeIndex + 1), delay);
      };
      const move = (change) => {
        showSlide(activeIndex + change);
        startAutoplay();
      };

      previousButton?.addEventListener('click', () => move(-1));
      nextButton?.addEventListener('click', () => move(1));
      dots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
          showSlide(index);
          startAutoplay();
        });
      });

      slider.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') move(-1);
        if (event.key === 'ArrowRight') move(1);
      });
      slider.addEventListener('mouseenter', stopAutoplay);
      slider.addEventListener('mouseleave', startAutoplay);
      slider.addEventListener('focusin', stopAutoplay);
      slider.addEventListener('focusout', startAutoplay);

      showSlide(0);
      startAutoplay();
    });
  }

  initRenimsHeroSlider();
  document.addEventListener('shopify:section:load', (event) => initRenimsHeroSlider(event.target));
  document.addEventListener('shopify:block:select', (event) => {
    const slide = event.target.closest('[data-hero-slide]');
    const slider = slide?.closest('[data-hero-slider]');
    if (!slide || !slider) return;
    const dots = [...slider.querySelectorAll('[data-slide-dot]')];
    dots[Number(slide.dataset.slideIndex)]?.click();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-testimonials"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.home-testimonials').forEach((section) => {
    if (section.dataset.carouselReady === 'true') return;

    const track = section.querySelector('[data-testimonial-track]');
    const previousButton = section.querySelector('[data-testimonial-prev]');
    const nextButton = section.querySelector('[data-testimonial-next]');

    if (!track || !previousButton || !nextButton) return;

    section.dataset.carouselReady = 'true';

    const scrollByCard = (direction) => {
      const card = track.querySelector('.home-testimonials__card');
      const gap = parseFloat(window.getComputedStyle(track).columnGap || '0');
      const distance = card ? card.getBoundingClientRect().width + gap : track.clientWidth;
      track.scrollBy({ left: distance * direction, behavior: 'smooth' });
    };

    previousButton.addEventListener('click', () => scrollByCard(-1));
    nextButton.addEventListener('click', () => scrollByCard(1));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations-benefits"] && !Shopify.designMode) return;
  try {
    
  function initializeRecommendationCarousels(root = document) {
    root.querySelectorAll('[data-recommendations-carousel]').forEach((carousel) => {
      if (carousel.dataset.initialized === 'true') return;
      carousel.dataset.initialized = 'true';

      const rail = carousel.querySelector('[data-carousel-rail]');
      const previous = carousel.querySelector('[data-carousel-previous]');
      const next = carousel.querySelector('[data-carousel-next]');
      if (!rail || !previous || !next) return;

      const updateButtons = () => {
        previous.disabled = rail.scrollLeft <= 2;
        next.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 2;
      };

      const scroll = (direction) => {
        const card = rail.querySelector('.product-recommendations-benefits__card');
        const gap = Number.parseFloat(getComputedStyle(rail).columnGap) || 0;
        rail.scrollBy({ left: direction * ((card?.offsetWidth || rail.clientWidth) + gap), behavior: 'smooth' });
      };

      previous.addEventListener('click', () => scroll(-1));
      next.addEventListener('click', () => scroll(1));
      rail.addEventListener('scroll', updateButtons, { passive: true });
      window.addEventListener('resize', updateButtons);
      updateButtons();
    });
  }

  initializeRecommendationCarousels();
  document.addEventListener('shopify:section:load', (event) => initializeRecommendationCarousels(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  class RenimsProduct {
    constructor(wrapper) {
      this.wrapper = wrapper;
      this.form = wrapper.querySelector('form');
      if (!this.form) return;

      this.section = wrapper.closest('.shopify-section');
      this.productRoot = wrapper.closest('.renims-product');
      this.productScript = this.section?.querySelector('[data-product-json]');
      if (!this.productScript) return;

      this.product = JSON.parse(this.productScript.textContent);
      this.variantInput = this.form.querySelector('[data-variant-id]');
      this.price = this.section.querySelector('[data-product-price]');
      this.comparePrice = this.section.querySelector('[data-compare-price]');
      this.availability = this.section.querySelector('[data-product-availability]');
      this.sku = this.section.querySelector('[data-product-sku]');
      this.addButton = this.form.querySelector('[data-add-to-cart]');
      this.addLabel = this.form.querySelector('[data-add-label]');
      this.addPrice = this.form.querySelector('[data-add-price]');
      this.quantityInput = this.form.querySelector('[data-quantity-input]');
      this.stickyButton = this.section.querySelector('[data-sticky-add]');
      this.stickyPrice = this.section.querySelector('[data-sticky-price]');
      this.gallery = this.section.querySelector('.renims-product__gallery');
      this.mediaItems = [...this.section.querySelectorAll('.renims-product__image-button[data-media-id]:not([data-carousel-clone])')];
      this.carouselItems = [...this.section.querySelectorAll('.renims-product__image-button[data-media-id]')];
      this.mediaThumbnails = [...this.section.querySelectorAll('[data-thumbnail-target][data-media-id]')];
      this.mediaCurrent = this.section.querySelector('[data-product-media-current]');
      this.carouselLoopTimer = null;
      this.labels = {
        addToCart: this.productRoot?.dataset.labelAddToCart || '',
        inStock: this.productRoot?.dataset.labelInStock || '',
        soldOut: this.productRoot?.dataset.labelSoldOut || ''
      };

      this.form.addEventListener('change', (event) => {
        if (event.target.matches('[data-option-input]')) {
          this.updateOptionAvailability();
          this.updateVariant();
        }
      });

      this.form.querySelector('[data-quantity-minus]')?.addEventListener('click', () => this.updateQuantity(-1));
      this.form.querySelector('[data-quantity-plus]')?.addEventListener('click', () => this.updateQuantity(1));
      this.stickyButton?.addEventListener('click', () => {
        if (!this.stickyButton.disabled) this.form.requestSubmit();
      });
      this.gallery?.addEventListener('scroll', () => {
        this.updateMediaIndicatorFromScroll();
        this.scheduleCarouselLoopReset();
      }, { passive: true });
      this.updateOptionAvailability();
      const initialVariant = this.product.variants.find((variant) => String(variant.id) === this.variantInput.value);
      this.updateMedia(initialVariant, false);
      this.updateMediaIndicatorFromScroll();
      window.requestAnimationFrame(() => this.centerInitialMedia(initialVariant));
    }

    selectedOptions() {
      return [1, 2, 3].map((position) => {
        return this.form.querySelector(`[name="option${position}"]:checked`)?.value;
      }).filter(Boolean);
    }

    updateVariant() {
      const selectedOptions = this.selectedOptions();
      const variant = this.product.variants.find((item) => {
        return item.options.every((option, index) => option === selectedOptions[index]);
      });

      if (!variant) return;

      this.variantInput.value = variant.id;
      this.price.textContent = this.formatMoney(variant.price);
      this.addPrice.textContent = this.formatMoney(variant.price);
      if (this.comparePrice) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          this.comparePrice.hidden = false;
          this.comparePrice.textContent = this.formatMoney(variant.compare_at_price);
        } else {
          this.comparePrice.hidden = true;
          this.comparePrice.textContent = '';
        }
      }
      if (this.availability) {
        this.availability.textContent = variant.available ? this.labels.inStock : this.labels.soldOut;
      }

      if (this.sku) this.sku.textContent = variant.sku || '';

      this.addButton.disabled = !variant.available;
      this.addLabel.textContent = variant.available ? this.labels.addToCart : this.labels.soldOut;
      if (this.stickyButton) {
        this.stickyButton.disabled = !variant.available;
        this.stickyButton.textContent = variant.available ? this.labels.addToCart : this.labels.soldOut;
      }
      if (this.stickyPrice) this.stickyPrice.textContent = this.formatMoney(variant.price);
      this.updateMedia(variant);

      selectedOptions.forEach((value, index) => {
        const label = this.section.querySelector(`[data-selected-option="${index + 1}"]`);
        if (label) label.textContent = value;
      });
    }

    updateMedia(variant, shouldScroll = true) {
      const mediaId = variant?.featured_media?.id || variant?.featured_image?.id;
      if (!mediaId) return;

      const mediaItem = this.mediaItems.find((item) => item.dataset.mediaId === String(mediaId));
      if (!mediaItem) return;

      this.mediaThumbnails.forEach((thumbnail) => {
        if (thumbnail.dataset.mediaId === String(mediaId)) {
          thumbnail.setAttribute('aria-current', 'true');
        } else {
          thumbnail.removeAttribute('aria-current');
        }
      });

      if (shouldScroll) {
        mediaItem.scrollIntoView({
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          block: 'nearest',
          inline: 'center'
        });
      }
      this.updateMediaIndicator(mediaItem);
    }

    updateMediaIndicator(activeItem) {
      if (!activeItem) return;

      const mediaId = activeItem.dataset.mediaId;
      const index = Number(activeItem.dataset.productImageIndex || 0);

      this.mediaThumbnails.forEach((thumbnail) => {
        if (thumbnail.dataset.mediaId === mediaId) {
          thumbnail.setAttribute('aria-current', 'true');
        } else {
          thumbnail.removeAttribute('aria-current');
        }
      });

      if (this.mediaCurrent) this.mediaCurrent.textContent = String(index + 1);
    }

    updateMediaIndicatorFromScroll() {
      const items = this.carouselItems?.length ? this.carouselItems : this.mediaItems;
      if (!this.gallery || items.length < 1) return;

      const galleryCenter = this.gallery.getBoundingClientRect().left + (this.gallery.clientWidth / 2);
      let activeItem = items[0];
      let closestDistance = Infinity;

      items.forEach((item) => {
        const rect = item.getBoundingClientRect();
        const itemCenter = rect.left + (rect.width / 2);
        const distance = Math.abs(galleryCenter - itemCenter);

        if (distance < closestDistance) {
          closestDistance = distance;
          activeItem = item;
        }
      });

      this.updateMediaIndicator(activeItem);
    }

    centerInitialMedia(variant) {
      if (!this.isMobileCarousel()) return;

      const mediaId = variant?.featured_media?.id || variant?.featured_image?.id;
      const initialItem = this.mediaItems.find((item) => item.dataset.mediaId === String(mediaId)) || this.mediaItems[0];

      initialItem?.scrollIntoView({
        behavior: 'auto',
        block: 'nearest',
        inline: 'center'
      });
      this.updateMediaIndicator(initialItem);
    }

    isMobileCarousel() {
      return this.gallery && this.carouselItems.length > this.mediaItems.length && window.matchMedia('(max-width: 640px)').matches;
    }

    scheduleCarouselLoopReset() {
      if (!this.isMobileCarousel()) return;

      window.clearTimeout(this.carouselLoopTimer);
      this.carouselLoopTimer = window.setTimeout(() => this.resetCarouselLoop(), 120);
    }

    resetCarouselLoop() {
      if (!this.isMobileCarousel()) return;

      const activeClone = this.closestCarouselItem()?.dataset.carouselClone;
      if (!activeClone) return;

      const realIndex = activeClone === 'last' ? this.mediaItems.length - 1 : 0;
      const realItem = this.mediaItems[realIndex];
      if (!realItem) return;

      realItem.scrollIntoView({
        behavior: 'auto',
        block: 'nearest',
        inline: 'center'
      });
      this.updateMediaIndicator(realItem);
    }

    closestCarouselItem() {
      const items = this.carouselItems?.length ? this.carouselItems : this.mediaItems;
      if (!this.gallery || items.length < 1) return null;

      const galleryCenter = this.gallery.getBoundingClientRect().left + (this.gallery.clientWidth / 2);
      let activeItem = items[0];
      let closestDistance = Infinity;

      items.forEach((item) => {
        const rect = item.getBoundingClientRect();
        const itemCenter = rect.left + (rect.width / 2);
        const distance = Math.abs(galleryCenter - itemCenter);

        if (distance < closestDistance) {
          closestDistance = distance;
          activeItem = item;
        }
      });

      return activeItem;
    }

    updateOptionAvailability() {
      const selectedPreviousOptions = [];

      [1, 2, 3].forEach((position) => {
        const inputs = [...this.form.querySelectorAll(`[name="option${position}"]`)];
        if (!inputs.length) return;

        inputs.forEach((input) => {
          const isAvailable = this.product.variants.some((variant) => {
            if (!variant.available || variant.options[position - 1] !== input.value) return false;
            return selectedPreviousOptions.every((value, index) => variant.options[index] === value);
          });

          input.disabled = !isAvailable;
          input.nextElementSibling?.classList.toggle('is-unavailable', !isAvailable);
        });

        let selectedInput = inputs.find((input) => input.checked && !input.disabled);
        if (!selectedInput) {
          selectedInput = inputs.find((input) => !input.disabled);
          if (selectedInput) selectedInput.checked = true;
        }

        if (selectedInput) selectedPreviousOptions.push(selectedInput.value);
      });
    }

    updateQuantity(change) {
      const current = Number(this.quantityInput.value || 1);
      this.quantityInput.value = Math.max(1, current + change);
    }

    formatMoney(cents) {
      const amount = new Intl.NumberFormat(document.documentElement.lang || 'en', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(cents / 100);

      if ((this.product.currency || 'INR') === 'INR') {
        return `Rs. ${amount}`;
      }

      return amount;
    }
  }

  class RenimsZoom {
    constructor(modal) {
      this.modal = modal;
      this.stage = modal.querySelector('[data-zoom-stage]');
      this.canvas = modal.querySelector('[data-zoom-canvas]');
      this.image = modal.querySelector('[data-zoom-image]') || this.canvas?.querySelector('img');
      this.level = modal.querySelector('[data-zoom-level]');
      this.items = [];
      this.currentIndex = 0;
      this.scale = 1;
      this.maxScale = 4;
      this.position = { x: 0, y: 0 };
      this.drag = null;
      this.touchPointers = new Map();
      this.pinch = null;
      this.didDrag = false;
      this.scope = modal.closest('.shopify-section') || document;
      if (!this.stage || !this.canvas || !this.image || !this.level) return;

      this.scope.querySelectorAll('[data-zoom-trigger]').forEach((trigger, index) => {
        if (!trigger.dataset.zoomSrc) return;

        const item = {
          src: trigger.dataset.zoomSrc,
          alt: trigger.dataset.zoomAlt,
          index: Number(trigger.dataset.zoomIndex || index)
        };

        if (!trigger.closest('[data-carousel-clone]')) {
          this.items.push(item);
        }
        trigger.addEventListener('click', () => this.open(item.src, item.alt, item.index));
      });

      modal.querySelectorAll('[data-zoom-close]').forEach((button) => {
        button.addEventListener('click', () => this.close());
      });

      this.toolbar = modal.querySelector('.renims-zoom__toolbar');
      this.toolbar?.addEventListener('click', (event) => {
        const button = event.target.closest('button');
        if (!button || !this.toolbar.contains(button)) return;

        event.preventDefault();
        event.stopPropagation();

        if (button.matches('[data-zoom-in]')) {
          this.zoomBy(0.5);
        } else if (button.matches('[data-zoom-out]')) {
          this.zoomBy(-0.5);
        } else if (button.matches('[data-zoom-reset]')) {
          this.reset();
        } else if (button.matches('[data-zoom-prev]')) {
          this.showAdjacent(-1);
        } else if (button.matches('[data-zoom-next]')) {
          this.showAdjacent(1);
        }
      });

      this.stage.addEventListener('wheel', (event) => {
        event.preventDefault();
        this.zoomBy(event.deltaY < 0 ? 0.25 : -0.25);
      }, { passive: false });

      this.stage.addEventListener('pointerdown', (event) => this.startDrag(event));
      this.stage.addEventListener('pointermove', (event) => this.moveDrag(event));
      this.stage.addEventListener('pointerup', (event) => this.endPointer(event));
      this.stage.addEventListener('pointercancel', (event) => this.endPointer(event));
      this.stage.addEventListener('click', (event) => this.toggleClickZoom(event));

      document.addEventListener('keydown', (event) => {
        if (!this.isOpen()) return;
        if (event.key === 'Escape') this.close();
        if (event.key === 'ArrowLeft') this.showAdjacent(-1);
        if (event.key === 'ArrowRight') this.showAdjacent(1);
      });
    }

    open(src, alt, index = 0) {
      let itemIndex = this.items.findIndex((item) => item.index === index);
      if (itemIndex < 0) itemIndex = this.items.findIndex((item) => item.src === src);
      this.currentIndex = itemIndex >= 0 ? itemIndex : 0;
      this.image.removeAttribute('srcset');
      this.image.src = src;
      this.image.alt = alt || '';
      this.reset();
      this.modal.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('renims-zoom-open');
    }

    showAdjacent(direction) {
      if (!this.items.length) return;
      const nextIndex = (this.currentIndex + direction + this.items.length) % this.items.length;
      const item = this.items[nextIndex];
      this.open(item.src, item.alt, item.index);
    }

    close() {
      this.modal.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('renims-zoom-open');
      this.endDrag();
    }

    isOpen() {
      return this.modal.getAttribute('aria-hidden') === 'false';
    }

    zoomBy(amount) {
      this.scale = Math.min(this.maxScale, Math.max(1, this.scale + amount));
      if (this.scale === 1) this.position = { x: 0, y: 0 };
      this.render();
    }

    zoomTo(scale, center = null) {
      const nextScale = Math.min(this.maxScale, Math.max(1, scale));
      const previousScale = this.scale;

      if (center && previousScale !== nextScale) {
        const ratio = nextScale / previousScale;
        this.position.x = center.x - ((center.x - this.position.x) * ratio);
        this.position.y = center.y - ((center.y - this.position.y) * ratio);
      }

      this.scale = nextScale;
      if (this.scale === 1) this.position = { x: 0, y: 0 };
      this.render();
    }

    reset() {
      this.scale = 1;
      this.position = { x: 0, y: 0 };
      this.render();
    }

    toggleClickZoom(event) {
      if (event.button !== 0) return;
      if (this.didDrag) {
        this.didDrag = false;
        return;
      }

      if (this.scale > 1) {
        this.reset();
      } else {
        this.zoomBy(1);
      }
    }

    startDrag(event) {
      if (event.button !== 0) return;
      if (event.pointerType === 'touch') {
        this.trackTouchPointer(event);

        if (this.touchPointers.size === 2) {
          this.startPinch();
        }

        return;
      }

      if (this.scale <= 1) return;
      this.didDrag = false;
      this.drag = {
        pointerId: event.pointerId,
        startX: event.clientX,
        startY: event.clientY,
        originX: this.position.x,
        originY: this.position.y
      };
      this.stage.setPointerCapture(event.pointerId);
    }

    moveDrag(event) {
      if (event.pointerType === 'touch') {
        if (!this.touchPointers.has(event.pointerId)) return;

        this.trackTouchPointer(event);
        if (this.touchPointers.size === 2) {
          event.preventDefault();
          this.movePinch();
          return;
        }
      }

      if (!this.drag) return;
      const deltaX = event.clientX - this.drag.startX;
      const deltaY = event.clientY - this.drag.startY;
      if (Math.abs(deltaX) > 3 || Math.abs(deltaY) > 3) this.didDrag = true;
      this.position.x = this.drag.originX + event.clientX - this.drag.startX;
      this.position.y = this.drag.originY + event.clientY - this.drag.startY;
      this.render();
    }

    endDrag() {
      this.drag = null;
      this.pinch = null;
      this.touchPointers.clear();
    }

    endPointer(event) {
      if (event.pointerType === 'touch') {
        const wasPinching = Boolean(this.pinch);
        this.touchPointers.delete(event.pointerId);
        this.pinch = null;
        this.didDrag = wasPinching;
      }

      if (this.drag?.pointerId === event.pointerId) {
        this.drag = null;
      }
    }

    trackTouchPointer(event) {
      this.touchPointers.set(event.pointerId, {
        x: event.clientX,
        y: event.clientY
      });

      if (this.stage.hasPointerCapture && !this.stage.hasPointerCapture(event.pointerId)) {
        this.stage.setPointerCapture(event.pointerId);
      }
    }

    startPinch() {
      const points = [...this.touchPointers.values()];
      const distance = this.touchDistance(points);
      if (distance <= 0) return;

      this.didDrag = true;
      this.drag = null;
      this.pinch = {
        distance,
        scale: this.scale,
        center: this.touchCenter(points),
        positionX: this.position.x,
        positionY: this.position.y
      };
    }

    movePinch() {
      if (!this.pinch) this.startPinch();
      if (!this.pinch) return;

      const points = [...this.touchPointers.values()];
      const distance = this.touchDistance(points);
      if (distance <= 0) return;

      const center = this.touchCenter(points);
      const nextScale = this.pinch.scale * (distance / this.pinch.distance);
      this.position.x = this.pinch.positionX + center.x - this.pinch.center.x;
      this.position.y = this.pinch.positionY + center.y - this.pinch.center.y;
      this.zoomTo(nextScale, center);
    }

    touchDistance(points) {
      const deltaX = points[0].x - points[1].x;
      const deltaY = points[0].y - points[1].y;
      return Math.hypot(deltaX, deltaY);
    }

    touchCenter(points) {
      return {
        x: (points[0].x + points[1].x) / 2,
        y: (points[0].y + points[1].y) / 2
      };
    }

    render() {
      this.canvas.style.transform = `translate(${this.position.x}px, ${this.position.y}px) scale(${this.scale})`;
      this.level.textContent = `${Math.round(this.scale * 100)}%`;
      this.stage.dataset.zoomed = this.scale > 1 ? 'true' : 'false';
    }
  }

  function initRenimsProduct(root = document) {
    root.querySelectorAll('[data-zoom-modal]').forEach((modal) => {
      if (modal.dataset.renimsZoomReady === 'true' && modal.renimsZoom) return;
      modal.dataset.renimsZoomReady = 'true';
      modal.renimsZoom = new RenimsZoom(modal);
    });

    root.querySelectorAll('[data-product-form-wrapper]').forEach((wrapper) => {
      if (wrapper.dataset.renimsProductReady === 'true') return;
      wrapper.dataset.renimsProductReady = 'true';
      new RenimsProduct(wrapper);
    });

    root.querySelectorAll('[data-share-button]').forEach((button) => {
      if (button.dataset.renimsShareReady === 'true') return;
      button.dataset.renimsShareReady = 'true';

      button.addEventListener('click', async () => {
        if (navigator.share) {
          await navigator.share({ title: document.title, url: window.location.href });
        } else {
          await navigator.clipboard.writeText(window.location.href);
          const productRoot = button.closest('.renims-product');
          button.textContent = productRoot?.dataset.labelLinkCopied || '';
        }
      });
    });

    root.querySelectorAll('[data-thumbnail-target]').forEach((button) => {
      if (button.dataset.renimsThumbReady === 'true') return;
      button.dataset.renimsThumbReady = 'true';

      button.addEventListener('click', () => {
        const target = document.getElementById(button.dataset.thumbnailTarget);
        if (!target) return;

        target.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        root.querySelectorAll('[data-thumbnail-target]').forEach((item) => item.removeAttribute('aria-current'));
        button.setAttribute('aria-current', 'true');
      });
    });

    root.querySelectorAll('[data-size-chart-modal]').forEach((modal) => {
      if (modal.dataset.renimsSizeChartReady === 'true') return;
      modal.dataset.renimsSizeChartReady = 'true';

      const section = modal.closest('.shopify-section') || document;
      const openButton = section.querySelector('[data-size-chart-open]');
      const closeButtons = modal.querySelectorAll('[data-size-chart-close]');

      const open = () => {
        modal.setAttribute('aria-hidden', 'false');
        document.documentElement.classList.add('renims-size-chart-open');
      };

      const close = () => {
        modal.setAttribute('aria-hidden', 'true');
        document.documentElement.classList.remove('renims-size-chart-open');
      };

      openButton?.addEventListener('click', open);
      closeButtons.forEach((button) => button.addEventListener('click', close));
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && modal.getAttribute('aria-hidden') === 'false') close();
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initRenimsProduct());
  } else {
    initRenimsProduct();
  }

  document.addEventListener('shopify:section:load', (event) => initRenimsProduct(event.target));

  } catch(e) { console.error(e); }
})();
})();
